import axios from "axios";

export async function getContact() {
    return await axios
        .get(`${process.env.REACT_APP_API_URL}getContact.php`)
        .then((res) => res.data)
        .catch((err) => {
            console.log(err);
            return {
                datas: [],
                album: []
            };
        });
}
